var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 2.25h.188c.31 0 .562-.252.562-.563V.563A.563.563 0 0 0 20.437 0H3.563A.563.563 0 0 0 3 .563v1.125c0 .31.252.562.563.562h.187c0 3.776 1.509 7.772 4.555 9.75-3.06 1.987-4.555 5.995-4.555 9.75h-.188a.563.563 0 0 0-.562.563v1.125c0 .31.252.562.563.562h16.875c.31 0 .562-.252.562-.563v-1.125a.563.563 0 0 0-.563-.562h-.187c0-3.776-1.509-7.772-4.555-9.75 3.06-1.987 4.555-5.995 4.555-9.75zM6 2.25h12c0 4.763-2.686 8.625-6 8.625S6 7.013 6 2.25zm12 19.5H6c0-4.763 2.686-8.625 6-8.625s6 3.862 6 8.625z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.bccd45740595004309172b6717d6d1dd.svg";
export { ForwardRef as ReactComponent };